// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"kpnaynEX","mobile":"mobile","scroller":"p2MlyvLk"};